import React from 'react';
import { Icon } from './Icon';

const EarningsIcon = ({ size }: Props) => {
  return (
    <Icon type="cash" color="bg-label-success" size={size} />
  );
}

interface Props {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
}

export { EarningsIcon };